import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
	static targets = [ "panel", "nextButton", "previousButton", "finishedButton", "progress" ]
	static values = { current: { type: Number, default: 0 } }
	
	connect() {
		this.panelTargets.forEach(el => el.hidden = true)
		this.panelTargets[this.currentValue].hidden = false
		this.progressTarget.max = this.panelTargets.length
	}
	
	multiSelection(e) {
		this.nextButtonTarget.hidden = !e.currentTarget.checkValidity()
	}
	
	selection(e) {
		this.next(e);
	}
	
	currentValueChanged(value, previous) {
		this.panelTargets[previous].hidden = true
		this.panelTargets[value].hidden = false
		
		this.previousButtonTarget.hidden = value === 0

		if (this.hasNextButtonTarget) {
			this.nextButtonTarget.hidden = true
		}
		
		this.finishedButtonTarget.hidden = !(value === this.panelTargets.length - 1)
		
		this.moveProgress(value);
	}
	
	moveProgress(panel) {
		this.progressTarget.value = panel
		this.progressTarget.innerText = `${panel} of ${this.progressTarget.max}`
	}
	
	next(e) {
		e.preventDefault();
		if (this.currentValue < this.panelTargets.length - 1) {
			this.currentValue += 1
		}
	}
	
	previous(e) {
		e.preventDefault();
		if (this.currentValue > 0) {
			this.currentValue -= 1
		}
	}
}